import React, { Component } from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import R from 'ramda'
import moment from 'moment'
import { Form as UnstyledForm} from 'formsy-react-2'
import { Table, TableCell, TextIcon, TableHeader, TableLoading, TextInput,
  Title, Colors, Button, Pagination, ContextMenu } from 'advenio-components'
import { connect } from 'react-redux'
import ReservationBmxActions from '../../Data/Redux/ReservationBmxRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import { parseFullName } from '../../utils/Utils'
import ConfirmResservationBmx from './ConfirmResservationBmx'

const FormContainer = styled.div`
  display: flex;
  width: 50%;
  margin: 0px 0px -60px 0px;
`
const Form = styled(UnstyledForm)`
  display: inline-block;
  flex-direction: column;
  width: 48%;
  margin-left: 52%;
`
const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: auto;
`
const InputContainer = styled.div`
    margin-right: 5px;
`
const Send = styled.div`
  height: auto;
  display: inline;
  box-sizing: border-box;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: 6%;
`
const TableContainer = styled.div`
  box-shadow: 1px 1px 16px 0px rgba(0,0,0, .3);
  border-radius: 4px;
`
const InfoCell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 12px;
  height: 26px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
`
const StudentName = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: ${Colors.blue500};
  cursor: pointer;
`
const ParentName = styled.span`
  margin-left: 4px;
  color: ${Colors.gray800}
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const Container = styled.div`
  padding: 54px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`
const ValidatedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 78px;
`

class ReservationsBmx extends Component {
  state = {
    typeModal: 'authorize',
    modalServiceOpen: false,
    pageSelected:1,
    queryParams: {},
    reservationId:0,
    modalResverationBmxOpen:false,
    student:null,
    reservations:[],
  }

  componentWillMount = () => {
      const { location: { search }, user:{ center_id }, getReservations } = this.props
    const queryParams = queryString.parse(search)
    if (queryParams.page) {
      this.setState({ pageSelected: parseInt(queryParams.page) })
    }
    this.setState({ queryParams })
    getReservations(center_id,queryParams)

  }

  componentWillReceiveProps (nextProps) {
    const { reservations } = this.props
    if(reservations !== nextProps.reservations && !nextProps.loading ){
      // const sortData = R.sortWith([R.ascend(R.prop('authorized_at'))])
      let reservationsSort = R.clone(nextProps.reservations)
      // reservationsSort.sort((a,b) => a.authorized_at > b.authorized_at ? 1 : -1 )
      reservationsSort.sort((a,b)=> (b.authorized_at === null) - (a.authorized_by === null) || a.authorized_at > b.authorized_at ? 1 : -1 )
      this.setState({reservations:reservationsSort})
      this.toggleModalReservationBmx(0,false)
    }
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { goTo, getReservations,  user:{ center_id } } = this.props

      const queries = { ...queryParams, page }
      getReservations(center_id ,queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  onFilter = (query) => {
    const queries = R.clone(query)
    const { goTo , getReservations, user:{ center_id } } = this.props
    Object.keys(queries).map((value) => {
      if (!query[value]) {
        delete queries[value]
      }
    })
    this.setState({queryParams:queries, pageSelected:1});
    goTo(`?${queryString.stringify(queries)}`)
    getReservations(center_id, queries)
  }

  navigateToProfile = (student) => {
    const { goTo, setActiveStudentId, setActiveClassroomId } = this.props
    const { classroom_id: classroomId, id: studentId } = student

    setActiveStudentId(Number(studentId))
    setActiveClassroomId(Number(classroomId))

    return goTo(`/classroom/${classroomId}/student/${studentId}`)
  }

  toggleModalReservationBmx = ( reservationId = 0, modalResverationBmxOpen = false, student = null, typeModal = null ) =>
    this.setState({ modalResverationBmxOpen,student,reservationId, typeModal },function(){
      if(typeModal === 'paid'){
        this.props.getStudentPayments(student.id)
      }
    })

  formatPayments = (payments) => (
    [{id:0,value:0,label:"Seleccione"}].concat(payments.map(p=>({
      id: p.id,
      value: p.id,
      label: `deposito $${p.amount} el ${p.paid_at}`
    })))
  )

  render() {
    const {
      meta,
      studentPayments,
      loading,
      loadingpost,
      loadingPayments,
      pendingReservationBmx,
      authrizeReservationBmx,
      cancelReservationBmx,
      paidReservationBmx,
    } = this.props
    const {
       pageSelected,
       queryParams,
       reservationId,
       modalResverationBmxOpen,
       student,
       typeModal,
       reservations,
    } = this.state

    const formatPayments = studentPayments.length > 0 ? this.formatPayments(studentPayments):[]

    return (
      <Container>
        <HeaderContainer>
          <Title>Reservaciónes Home</Title>
          <FormContainer>
            <Form onSubmit={this.onFilter}>
                <FiltersContainer>
                  <InputContainer>
                    <TextInput
                      name="name"
                      label="Nombre del Alumno"
                      value={queryParams.name || ''}
                      />
                  </InputContainer>
                  <Send>
                  <Button marginRight="70%" width="21%" loading={loading} primary small type="submit">Filtrar</Button>
                  </Send>
                </FiltersContainer>
            </Form>
          </FormContainer>
        </HeaderContainer>
        <PaginationContainer>
          <Pagination
            totalElements={meta && meta.total}
            elementsPerPage={meta && meta.per_page}
            onPageClick={this.onClickPage}
            pageSelected={pageSelected}
          />
        </PaginationContainer>
        {loading ?
          <TableLoading
            roundedCorners
            columns={[
              {
                id: 1,
                header: 'Alumno / Tutor',
                element: 'Text',
                center: true,
              },
              {
                id: 2,
                header: 'Alumnos Adicionales',
                element: 'Text',
                center: true,
              },
              {
                id: 3,
                header: 'Servicio',
                element: 'Text',
                center: true,
              },
              {
                id: 4,
                header: 'Fechas',
                element: 'Text',
                center: true,
              },
              {
                id: 5,
                header: 'Horas',
                element: 'Text',
                center: true,
              },
              {
                id: 6,
                header: 'Autorizado',
                element: 'Text',
                center: true,
              },
              {
                id: 7,
                header: 'Estatus',
                element: 'Text',
                center: true,
              },
              {
                id: 8,
                header: '',
                element: 'Text',
                center: true,
              }
            ]}
            rows={8}
          /> :
          <TableContainer>
            <Table
              roundedCorners
              data={reservations}
              columns={[
                {
                  id: 1,
                  Header: () => <TableHeader title="Alumno / Tutor" blue center />,
                  accessor: ({ student_principal, parent }) => ({ student_principal, parent }),
                  Cell: ({ value: { student_principal, parent } }) => (
                  <TableCell center>
                      <InfoCell>
                        <InfoRow>
                          <StudentName onClick={() => this.navigateToProfile(student_principal)}>
                            {student_principal && student_principal.fullName}
                          </StudentName>
                        </InfoRow>
                        <InfoRow>
                          Tutor: <ParentName>{parent && parent.name}</ParentName>
                        </InfoRow>
                      </InfoCell>
                    </TableCell>
                  ),//<TableCell center>{student}</TableCell>,
                },
                {
                  id: 2,
                  Header: () =>  <TableHeader title="Alumnos Adicionales" blue center />,
                  accessor: ({ detail }) => detail,
                  Cell: ({ value: detail }) =>
                    <TableCell center>Alumnos Adcionales: {detail ? detail.additional_students : 0}</TableCell>,
                },
                {
                  id: 3,
                  Header: () =>  <TableHeader title="Servicio" blue center />,
                  accessor: ({ service_type }) => service_type,
                  Cell: ({ value: service_type }) =>
                    <TableCell center>{service_type.name}</TableCell>,
                },
                {
                  id: 4,
                  Header: () => <TableHeader title="Fechas" blue center />,
                  accessor: ({ from_date, to_date  }) => ({from_date, to_date }),
                  Cell: ({ value: { from_date, to_date  } }) => <TableCell center>  {from_date+' a '+to_date}</TableCell>,
                },
                {
                  id: 5,
                  Header: () =>  <TableHeader title="Horas" blue center />,
                  accessor: ({ from_time, to_time  }) => ({ from_time, to_time }),
                  Cell: ({ value: { from_time, to_time } }) => <TableCell center>  {from_time+' a '+to_time}</TableCell>,
                },
                {
                  id: 6,
                  Header: () =>  <TableHeader title="Autorizado" blue center />,
                  accessor: ({ authorized_by  }) => ({ authorized_by,  }),
                  Cell: ({ value: { authorized_by, } }) => <TableCell center>  {authorized_by.user|| null}</TableCell>,
                },
                {
                  id: 7,
                  Header: () =>  <TableHeader title="Estatus" blue center />,
                  accessor: ({ status  }) => ({ status  }),
                  Cell: ({ value: { status, } }) => <TableCell center>  {status.name|| null}</TableCell>,
                },
                {
                  id: 8,
                  Header: () => <TableHeader title="" center blue />,
                  accessor: ({ id, student_principal, authorized_at, status }) => ({ id, student_principal, authorized_at, status }),
                  maxWidth:100,
                  Cell: ({ value: {id, student_principal, authorized_at, status } }) => {

                    const elements = []

                    if(status.id === 3  && status.id !== 2 && status.id !== 1 && status.id !== 6)
                    {
                      elements.push({
                        id: 1,
                        icon: 'checkmark',
                        label: 'Autorizar',
                        onClick: () => {this.toggleModalReservationBmx(id, true, (student_principal),'authorize')},
                      })
                    }

                    // if(status.id === 5  && status.id !== 2 && status.id !== 1 && status.id !== 6){
                    //   elements.push({
                    //     id: 1,
                    //     icon: 'close',
                    //     label: 'Desautorizar',
                    //     onClick: () => {this.toggleModalReservationBmx(id, true, (student_principal),'pending')},
                    //   })
                    // }

                    if(status.id === 7){
                      elements.push({
                        id: 1,
                        icon: 'checkmark',
                        label: 'Pagado',
                        onClick: () => {this.toggleModalReservationBmx(id, true, (student_principal),'paid')},
                      })
                    }
                    if(status.id !== 5 && status.id !== 2 && status.id !== 1){
                      elements.push({
                        id: 2,
                        icon: 'close',
                        label: 'Cancelar',
                        onClick: () => {this.toggleModalReservationBmx(id, true, (student_principal),'cancel')},
                      })
                    }
                    return (
                      <Actions>
                        {elements.length > 0&&(
                          <ContextMenu
                              value={1}
                              elements={elements}
                          />
                        )}
                      </Actions>
                    )
                },
                  },
              ]}
            />
          </TableContainer>
        }
        {modalResverationBmxOpen && (
          <ConfirmResservationBmx
            isOpen={modalResverationBmxOpen}
            onClose={() => this.toggleModalReservationBmx(0,false)}
            itemId={reservationId}
            handleSubmit={typeModal === 'authorize' ? authrizeReservationBmx :typeModal === 'pending' ? pendingReservationBmx :typeModal === 'paid' ? paidReservationBmx : cancelReservationBmx}
            loading={loadingpost}
            loadingPayments={loadingPayments}
            payments={formatPayments}
            typeToDelete="Reservación"
            modalTitle={student}
            typeModal={typeModal}
          />
        )}
      </Container>
    )
  }
}


ReservationsBmx.defaultProps = {
  loading: false,
  reservations: [],
  meta: {},
  location: {},
  studentPayments:[],
}

const mapStateToProps = state => ({
  /** Error and loading for modal options */
    loading: state.reservationBmx.get.fetching,
    reservations: state.reservationBmx.get.results.data,
    meta: state.reservationBmx.get.results,
    user: state.auth.user,
    loadingpost: state.reservationBmx.postReservation.fetching,
    loadingPayments:state.reservationBmx.studentPayments.fetching,
    studentPayments: state.reservationBmx.studentPayments.results
})

const mapDispatchToProps = dispatch => ({
  getReservations: (centerId,query) => dispatch(ReservationBmxActions.getReservationBmxRequest(centerId,query)),
  authrizeReservationBmx: reservationId => dispatch(ReservationBmxActions.authorizeReservationBmxRequest(reservationId)),
  cancelReservationBmx: reservationId => dispatch(ReservationBmxActions.cancelReservationBmxRequest(reservationId)),
  pendingReservationBmx: reservationId => dispatch(ReservationBmxActions.pendingReservationBmxRequest(reservationId)),
  paidReservationBmx: (reservationId,paymentId) => dispatch(ReservationBmxActions.paiedReservationBmxRequest(reservationId,paymentId)),
  getStudentPayments: studentId => dispatch(ReservationBmxActions.getStudentPaymentsRequest(studentId)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
 goTo: path => dispatch(push(path)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReservationsBmx)



// WEBPACK FOOTER //
// ./src/Containers/ReservationBMX/index.jsx